import React from "react";
import {
  FileInput,
  FormGroup,
  Dialog,
  Classes,
  Intent,
  Button,
} from "@blueprintjs/core";

class DialogAddResource extends React.Component {
  render() {
    const {
      resources,
      dialogIsOpen,
      submiting,
      onCloseDialog,
      onChangeFileInput,
      onAddResource
    } = this.props;

    return (
      <Dialog
        icon="cloud-upload"
        title="Download image / video"
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        usePortal={true}
        enforceFocus={true}
        isOpen={dialogIsOpen}
        onClose={onCloseDialog}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup
            label="File"
            labelFor="resource-file"
            disabled={submiting}
          >
            <FileInput
              id="resource-file"
              fill={true}
              inputProps={{ name: "file", multiple: true }}
              onInputChange={onChangeFileInput}
              disabled={submiting}
              text={"Add files..."}
            />
          </FormGroup>
        </div>
        {resources.length > 0 &&
          <div className='large-hoz-padding margin-bottom-large'>
            {resources.map((resource, i) => <span key={i}>{resource.name} <br /></span>)}
          </div>
        }
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              onClick={onCloseDialog}
              text="Cancel"
              disabled={submiting}
            />
            <Button
              onClick={onAddResource}
              text="Download"
              intent={Intent.SUCCESS}
              rightIcon="cloud-upload"
              disabled={
                submiting ||
                resources.length < 1
              }
              loading={submiting}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default DialogAddResource;
